import { render, staticRenderFns } from "./QuotationImportPanel.vue?vue&type=template&id=14081006&scoped=true"
import script from "./QuotationImportPanel.vue?vue&type=script&lang=js"
export * from "./QuotationImportPanel.vue?vue&type=script&lang=js"
import style0 from "./QuotationImportPanel.vue?vue&type=style&index=0&id=14081006&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14081006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14081006')) {
      api.createRecord('14081006', component.options)
    } else {
      api.reload('14081006', component.options)
    }
    module.hot.accept("./QuotationImportPanel.vue?vue&type=template&id=14081006&scoped=true", function () {
      api.rerender('14081006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/QuotationCenter/components/QuotationImportPanel.vue"
export default component.exports